




















import {Component, Vue, Prop} from 'vue-property-decorator'
import {$, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import MotoristaEResponsaveisRequest from '@/model/request/MotoristaEResponsaveisRequest'

const metaInfo = () => ({
  title: $.t('view.persist.driverConnect.title'),
})

@Component({
  metaInfo,
})
export default class DriverConnectView extends Vue {
  AppConfig = AppConfig
  motoristaReq = new MotoristaEResponsaveisRequest()

  async connect() {
    await this.motoristaReq.motorista.connect(this.motoristaReq.motorista.cpf , 'connect')
    successAndPush('system.success.persist', '/manage/driver/list')
  }
}
